import React, { useState, useEffect, useContext } from "react"
import styled from "styled-components"
import { SectionContext } from "../context/sectionContext"
import { ConditionContext } from "../context/conditionContext"
import { ErrorContext } from "../context/errorContext"
import { JourneyContext } from "../context/journeyContext"
import { getValueFromJourney } from "../services/helperFunctions"
import { lineCapital, wordCapital } from "../../shared/functions"
import Parser from 'html-react-parser';

const PortfolioContainer = styled.div`
  display: flex;
  margin-bottom: 1rem;

  @media screen and (max-width: 980px) {
    flex-direction: column;
  }

  .left-addon input[type="checkbox"].css-checkbox:checked + label.css-label,
  input[type="radio"].css-checkbox:checked + label.css-label {
    background-position: 0 -54px;
  }

  @media (max-width: 767px){
    .left-addon input[type="checkbox"].css-checkbox ~ label.css-label {
      background-size: 27px;
    }
  }
`

const InputContainer = styled.div`
  display: block;
  flex-direction: column;
  margin: 15px 0;
  position: relative;
  box-sizing: border-box;
  font-size: 15px;
  color: #505050;
  float: left;
  margin-left: auto;
  
  input[type=number]::-webkit-inner-spin-button, 
  input[type=number]::-webkit-outer-spin-button
  { 
    -webkit-appearance: none; 
    margin: 0; 
  }

  @media screen and (max-width: 980px) {
    margin-left: 0;
  }
  

  & > .str-input {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
  & input {
    border: none;
    outline: none;
    margin: 0;
    padding: 0;
    line-height: 4;
    height: 42px;
    background: ${props => props.channel === "A" ? "#ededed" : "#fff"};
    background: var(--lumiq-bg);
    text-align: center;
  }

  & > label {
    margin-left: 8px;
    margin-bottom: 5px;
    color: #505050;
    font-size: 16px;
    background: ${props => props.channel === "A" ? "#ededed" : "#fff"};
    background: var(--lumiq-bg);
    padding: 2px 5px;
    /* z-index: 999; */
    position: relative;
    display: inline-block;
    cursor: default;
    max-width: 100%;
    // min-height: 2rem;
  }
`

export default function ComponentFormPortfolioFields(props) {
  const [sectionState, setSectionState] = useContext(SectionContext)
  const [conditionState, setConditionState] = useContext(ConditionContext)
  const [errorState, setErrorState] = useContext(ErrorContext)
  const [journeyState, setJourneyState] = useContext(JourneyContext)
  const [showLocalError, setShowLocalError] = useState(false)



  // useEffect(()=>{
  //   //HSBC enabled checkbox and input field
  //   const urlParams = new URLSearchParams(window.location.search);
  //   const source = urlParams.get("source");
  //   let src = false;
  //   if (source?.toLowerCase() == "hsbc" || props.channel == "A") {
  //       src = true;
  //   }
  //   if(props?.data?.PFCheckbox?.formControlKey == "portfolioF9" && src && !sectionState?.sectionData?.totalFundValue ) {
  //       setSectionState(prev => {
  //         return {
  //           ...prev,
  //           sectionData: {
  //             ...prev.sectionData,
  //             [props.data.PFCheckbox.formControlKey]: true,
  //             [props.data.PFInput.formControlKey]: 100,
  //           },
  //         }
  //       })
  //       props.handleTotalPercentageCalculation()
  //   }
  // },[props?.data?.PFCheckbox])
    
  useEffect(() => {
    if (!sectionState.sectionData?.[props.data.PFCheckbox.formControlKey]) {
        if (props.data.PFCheckbox.checked) {
          if (sectionState.sectionId === props.sectionId) {
            setSectionState(prev => {
              return {
                ...prev,
                sectionData: {
                  ...prev.sectionData,
                  [props.data.PFCheckbox.formControlKey]: props.data.PFCheckbox.checked,
                },
              }
            })
          } else {
            setSectionState(prev => {
              return {
                ...prev,
                sectionId: props.sectionId,
                sectionData: {
                  ...prev.sectionData,
                  [props.data.PFCheckbox.formControlKey]: props.data.PFCheckbox.checked,
                },
              }
            })
          }
          setConditionState(prev => {
            return {
              ...prev,
              [`${props.pageId}.${props.sectionId}.${props.data.PFCheckbox.formControlKey}`]: props.data.PFCheckbox.checked,
            }
          })
        }
     
    }else{
      setConditionState(prev => {
        return {
          ...prev,
          [`${props.pageId}.${props.sectionId}.${props.data.PFCheckbox.formControlKey}`]: sectionState.sectionData[props.data.PFCheckbox.formControlKey],
        }
      })
    }
  }, [])

  useEffect(()=>{
    validate({value: sectionState.sectionData?.[props.data.PFCheckbox.formControlKey]?? ""})
  },[sectionState.sectionData?.[props.data.PFCheckbox.formControlKey]])

  useEffect(()=>{
    validateInput({value: sectionState.sectionData?.[props.data.PFInput.formControlKey]?? ""})
  },[sectionState.sectionData?.[props.data.PFInput.formControlKey]])

  const validate = (target) =>  {
    if(props.data.PFCheckbox.required){ // required field validation
      if(sectionState.sectionData && ((sectionState.sectionData[props.data.PFCheckbox.formControlKey] === "") || (!sectionState.sectionData[props.data.PFCheckbox.formControlKey]))){
        setErrorState( prev => {
          return ({
            ...prev,
            [props.data.PFCheckbox.formControlKey]: props.data.PFCheckbox.requiredError
            ? lineCapital(getValueFromJourney(
              journeyState.lookup.required_error,
              props.data.PFCheckbox.requiredError
            )): `Error Code Not Found in Strapi`,
          })
        })
      }else{
        setErrorState(prev => {
          return({
            ...prev,
            [props.data.PFCheckbox.formControlKey]: ""
          })
        })
      }
    }
    return
  }

  const validateInput = target => {
    if (props.data.PFInput.required && 
      (sectionState.sectionData?.[props.data.PFCheckbox.formControlKey] === "" ||
      sectionState.sectionData?.[props.data.PFCheckbox.formControlKey])) {
      // required field validation
      if (
        sectionState.sectionData?.[props.data.PFInput.formControlKey] === "" ||
        !sectionState.sectionData?.[props.data.PFInput.formControlKey]
      ) {
        setErrorState(prev => {
          return {
            ...prev,
            [props.data.PFInput.formControlKey]: props.data.PFInput.requiredError
            ? lineCapital(getValueFromJourney(
              journeyState.lookup.required_error,
              props.data.PFInput.requiredError
            )): `Error Code Not Found in Strapi`,
          }
        })
        return
      } else {
        setErrorState(prev => {
          return {
            ...prev,
            [props.data.PFInput.formControlKey]: "",
          }
        })
      }
      if (target.value) {
        setErrorState(prev => {
          return {
            ...prev,
            [props.data.PFInput.formControlKey]: "",
          }
        })
      }
    }
    if (target.value) {
      if (props.data.PFInput.min_len) {
        // min_len validation
        if (target.value.length < props.data.PFInput.min_len) {
          setErrorState(prev => {
            return {
              ...prev,
              [props.data.PFInput.formControlKey]:  lineCapital(getValueFromJourney(
                  journeyState.lookup.min_error,
                  props.data.PFInput.min_len_error
                ))
            }
          })
          setShowLocalError(true)
          return
        } else {
          setErrorState(prev => {
            return {
              ...prev,
              [props.data.PFInput.formControlKey]: "",
            }
          })
        }
      }
      if (props.data.PFInput.max_length) {
        //max length validation
        if (target.value.length > props.data.PFInput.max_length) {
            setErrorState(prev => {
              return {
                ...prev,
                [props.data.PFInput.formControlKey]: lineCapital(getValueFromJourney(
                    journeyState.lookup.max_error,
                    props.data.PFInput.max_len_error
                  ))
              }
            })

          setShowLocalError(true)
          return
        } else {
          setErrorState(prev => {
            return {
              ...prev,
              [props.data.PFInput.formControlKey]: "",
            }
          })
        }
      }
      if(props.data.PFInput.min_value) {
        let value = parseInt(target.value)
        console.log(typeof(value))
        if(value < props.data.PFInput.min_value){
            setErrorState(prev => {
              return {
                ...prev,
                [props.data.PFInput.formControlKey]: lineCapital(getValueFromJourney(
                    journeyState.lookup.min_error,
                    props.data.PFInput.min_value_error
                  ))

              }
            })
        setShowLocalError(true)
        return
      }
      else{
        setErrorState(prev => {
          return({
            ...prev,
            [props.data.PFInput.formControlKey]: ""
          })
        })
      }
      }
      if(props.data.PFInput.max_value) {
        let value = parseInt(target.value)
        console.log(typeof(value))
        if(parseInt(target.value) > props.data.PFInput.max_value){
            setErrorState(prev => {
              return {
                ...prev,
                [props.data.PFInput.formControlKey]: lineCapital(getValueFromJourney(
                    journeyState.lookup.max_error,
                    props.data.PFInput.max_value_error
                  ))
              }
            })
            setShowLocalError(true)
            return
          }
          else{
            setErrorState(prev => {
              return({
                ...prev,
                [props.data.PFInput.formControlKey]: ""
              })
            })
          }
      }
    } else {
      setErrorState(prev => {
        return {
          ...prev,
          [props.data.formControlKey]: "",
        }
      })
    }
    return
  }

  const handleChange = target => {
    if (sectionState.sectionId === props.sectionId) {
      setSectionState(prev => {
        return {
          ...prev,
          sectionData: {
            ...prev.sectionData,
            [props.data.PFCheckbox.formControlKey]: sectionState.sectionData[props.data.PFCheckbox.formControlKey] ? !sectionState.sectionData[props.data.PFCheckbox.formControlKey] : true 
          },
        }
      })
    } else {
      setSectionState(prev => {
        return {
          ...prev,
          sectionId: props.sectionId,
          sectionData: {
            ...prev.sectionData,
            [props.data.PFCheckbox.formControlKey]: sectionState.sectionData[props.data.PFCheckbox.formControlKey] ? !sectionState.sectionData[props.data.PFCheckbox.formControlKey] : true 
          },
        }
      })
    }
    setConditionState(prev => {
      return {
        ...prev,
        [`${props.pageId}.${props.sectionId}.${props.data.PFCheckbox.formControlKey}`]: sectionState.sectionData[props.data.PFCheckbox.formControlKey] ? !sectionState.sectionData[props.data.PFCheckbox.formControlKey] : true 
      }
    })
    let portFolioCheck = sectionState.sectionData[props.data.PFCheckbox.formControlKey] ? !sectionState.sectionData[props.data.PFCheckbox.formControlKey] : true 
    if (portFolioCheck) {
      setErrorState(prev => {
        return {
          ...prev,
          [props.data.PFInput.formControlKey]: props.data.PFInput.requiredError
          ? lineCapital(getValueFromJourney(
            journeyState.lookup.required_error,
            props.data.PFInput.requiredError
          )): `Error Code Not Found in Strapi`,
        }
      })
      return
    } else {
      setErrorState(prev => {
        return {
          ...prev,
          [props.data.PFInput.formControlKey]: "",
        }
      })
      props.handleCheckboxPercentageDeletion(sectionState.sectionData[props.data.PFInput.formControlKey])
      setSectionState(prev => {
        return {
          ...prev,
          sectionData: {
            ...prev.sectionData,
            [props.data.PFInput.formControlKey]: 0
          },
        }
      })
    }
    validate(target)
  }

  const handleChangeInput = ({ target }) => {
    if(target.value > 100){
      target.value = 100
    }
    if (sectionState.sectionId === props.sectionId) {
      setSectionState(prev => {
        return {
          ...prev,
          sectionData: {
            ...prev.sectionData,
            [props.data.PFInput.formControlKey]: target.value ?? "",
          },
        }
      })
    } else {
      setSectionState(prev => {
        return {
          ...prev,
          sectionId: props.sectionId,
          sectionData: {
            ...prev.sectionData,
            [props.data.PFInput.formControlKey]: target.value ?? "",
          },
        }
      })
    }
    setConditionState(prev => {
      return {
        ...prev,
        [`${props.pageId}.${props.sectionId}.${props.data.PFInput.formControlKey}`]: props.data.showInCaps ? target.value && target.value?.toUpperCase() : target.value,
      }
    })
    validate(target)
    //console.log(sectionState, "section state")
  }

  // if (props.data?.PFInput?.formControlKey === "portfolioF9text" || props.data?.PFCheckbox?.formControlKey === "portfolioF9"){ // NFO Period, remove this post nfo
  //   if (props.channel !== "A"){
  //     return null;  
  //   }
  // }

  return (
    <>
      <PortfolioContainer
        className={`form-group ${props.data.disabled ? "disable-input" : ""}`}
      >
        <div className={`checkbox-container `}>
          <div className="inner-addon left-addon">
            <div className="checkbox1">
              <input
                id={props.data.PFCheckbox.formControlKey}
                className={`css-checkbox form-control`}
                aria-hidden="true"
                type="checkbox"
                disabled = {props.data.PFCheckbox.disabled? true : false}
                checked={sectionState?.sectionData[props.data.PFCheckbox.formControlKey]}
                onClick={handleChange}
              />

              <label
                htmlFor={props.data.PFCheckbox.formControlKey}
                className="css-label"
              >
                <span style={{ display: "block" }}>
                  <span style={{ marginRight: "5px" }}>
                  {(getValueFromJourney(
          journeyState.lookup.label,
          props.data.PFCheckbox.label
        )) || props.data.PFCheckbox.label}
                  </span>
                  {props.data.PFCheckbox.info &&
                          <span style={{ marginLeft: "10px" }} className="tooltip-col text-tool-tip-design existing-tool-tip">
                            <div className="tool">i</div>
                            <span className="tooltiptext4 tooltiptext5 tooltiptext4-align-list " style={{ width: "22rem", height: "fit-content", top: "auto", pointerEvents: "none" }}>
                              {Parser((getValueFromJourney(
                                journeyState.lookup.tooltip,
                                props.data.PFCheckbox.info
                              )))}
                            </span>
                          </span>
                        }
                </span>
                <span>
                  {props.data.PFCheckbox.description}{" "}
                  <sub style={{ bottom: "1px" }}>
                  {(getValueFromJourney(
                            journeyState.lookup.label,
                            props.data.PFCheckbox.smallText
                          )) || props.data.PFCheckbox.smallText}
                  </sub>{" "}
                </span>
              </label>
            </div>
          </div>
        </div>

        <InputContainer channel={props.channel}>
          <div className="form-control str-input">
            <input
              type="number"
              name={props.data.PFInput.name}
              required={sectionState.sectionData[
                props.data.PFCheckbox.formControlKey
              ] ? sectionState.sectionData[
                props.data.PFCheckbox.formControlKey
              ]: false}
              placeholder={(getValueFromJourney(
                journeyState.lookup.placeholder,
                props.data.PFInput.placeholder
              )) || props.data.PFInput.placeholder}
              disabled={props.data.PFInput.disabled ? true : sectionState.sectionData[
                props.data.PFCheckbox.formControlKey
              ] ? !sectionState.sectionData[
                props.data.PFCheckbox.formControlKey
              ]: true}
              id={
                props.data.PFInput.id
                  ? props.data.PFInput.id
                  : props.data.PFInput.label
              }
             onChange={handleChangeInput}
              value={
                sectionState.sectionData[
                  props.data.PFInput.formControlKey
                ]
                  ? sectionState.sectionData[
                      props.data.PFInput.formControlKey
                    ]
                  : ""
              }
              onBlur={e => {
                validateInput(e.target)
                props.handleTotalPercentageCalculation()
              }}
            />
          </div>
          <span className="input-error">
            {(props.showError || showLocalError) &&
              errorState[props.data.PFInput.formControlKey]}
          </span>
        </InputContainer>
      </PortfolioContainer>
    </>
  )
}
